import { t } from '@cloudsuite/mosaic-shared/translations/translator.js'
import type { VariantMatrixSelectedFilter } from './typing/variant-matrix-typing.js'

// Stock is not a backend attribute: it is applied through the `in_stock` query param
// plus client-side filtering, so it never appears in `selected_filters`. This sentinel
// lets it travel as a regular selected filter (chips, badge count, slide-in state).
export const STOCK_FILTER_API_LINK = '__variant_matrix_stock_only__'

export function getStockFilterSectionLabel(): string {
  return String(t('in_stock', {
    ns: 'csc-variant-matrix-filter-slide-in',
    default: 'In stock',
  }))
}

export function getStockFilterOptionLabel(): string {
  return String(t('yes', {
    ns: 'csc-variant-matrix-filter-slide-in',
    default: 'Yes',
  }))
}

export function getStockFilterLabel(): string {
  return `${getStockFilterSectionLabel()} - ${getStockFilterOptionLabel()}`
}

export function createStockSelectedFilter(): VariantMatrixSelectedFilter {
  return {
    name: getStockFilterLabel(),
    api_link: STOCK_FILTER_API_LINK,
  }
}

export function isStockSelectedFilter(filter: { api_link?: string }): boolean {
  return filter.api_link === STOCK_FILTER_API_LINK
}
